import type { CurrencyId } from "@/services/currencies/currenciesTypes";
import { hasSelectedPaymentMethod, hasSelectedShippingMethod } from "@/services/marketplace/cart/cartHelpers";
import { type ShoppingCart, type SingleSellerCart } from "@/services/marketplace/cart/cartTypes";

export class InvalidCurrencyCombinationInCart extends Error {}

export const assertAllItemsInSingleSellerCartOfSameCurrency = (cart: SingleSellerCart): void => {
  let currencyId: CurrencyId | undefined = undefined;
  cart.items.forEach(({ price }) => {
    if (currencyId === undefined) {
      currencyId = price.currencyId;
    } else {
      if (currencyId !== price.currencyId) {
        throw new InvalidCurrencyCombinationInCart("Cart contains items with different currencies!");
      }
    }
  });
};

export const assertAllCommissionsOfSameCurrency = (cart: ShoppingCart): void => {
  let currencyId: CurrencyId | undefined = undefined;
  cart.subcarts.forEach(({ priceCommission }) => {
    if (currencyId === undefined) {
      currencyId = priceCommission.currencyId;
    } else {
      if (currencyId !== priceCommission.currencyId) {
        throw new InvalidCurrencyCombinationInCart("Cart contains commissions with different currencies!");
      }
    }
  });
};

export const isOrderSubmittable = (sellerCart: SingleSellerCart, fullCart: ShoppingCart | undefined): boolean => {
  if (!hasSelectedPaymentMethod(fullCart)) {
    return false;
  }

  if (!hasSelectedShippingMethod(fullCart)) {
    return false;
  }

  if (sellerCart.items.length === 0) {
    return false;
  }

  return true;
};
